import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SAAS_SAVE_DRAFT, SAAS_SAVE_DRAFT_SUCCESS, SAAS_SAVE_DRAFT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* saasSaveDraft({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/other-gm-prices`,
      method: 'POST',
      data: payload.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SAAS_SAVE_DRAFT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SAAS_SAVE_DRAFT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SAAS_SAVE_DRAFT_ERROR, payload: error });
  }
}

export function* watchSaasSaveDraft() {
  yield takeEvery(SAAS_SAVE_DRAFT, saasSaveDraft);
}

function* saasSaveDraftSaga() {
  yield all([fork(watchSaasSaveDraft)]);
}

export default saasSaveDraftSaga;
